/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmVectorStoresSearch } from "../../funcs/llmVectorStoresSearch.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.SearchVectorStoreRequest$inboundSchema,
};

export const tool$llmVectorStoresSearch: ToolDefinition<typeof args> = {
  name: "llm-vector-stores-search",
  description: `Search a vector store

Performs semantic search within a vector store to find the most relevant document chunks for a query.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmVectorStoresSearch(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
